module.exports = __webpack_public_path__ + "static/media/team-health-pool-site.2def6ad2.jpg";